module.exports = __webpack_public_path__ + "static/media/level-up.fa793384.svg";